window.allowAdd = true
allowEdit = true

$(document).ready ->

  category_count = 0
  change_order = false
  change_item_order = false
  uiItem = ''
  deleteUrl = ''
  parentModal = ''
  bulk_tag_selected = 0
  bulk_tag = ""
  bulk_label = ""
  cropbox = $('#add_person_image_cropbox')
  add_croppie_people = ''
  fileObject = {}

  modal_link = window.location.search.split("modal=")[1]
  if !!modal_link
    modal_link = decodeURIComponent(modal_link.split("&")[0])
    setTimeout (->
      $("[href='#{modal_link}']").click()
      return
    ), 250

  $('.get-tag-list').click (event) ->
    if bulk_tag_selected >= 1
      $('#bulk_list').show()
  
  $('.bulk-tag-custom-box').click (event) ->
    class_names = $(this).attr('class')
    if class_names.indexOf('user-available-tag') != -1
      if bulk_tag_selected == 1
        alert "Only one tag can be selected."
        return
      $(this).removeClass 'user-available-tag'
      $(this).addClass 'user-selected-tag'
      $(this).find('.tag-close').text 'x'
      names = $(event.target).attr('class')
      if names.indexOf('country') != -1
        $('#bulk_label').val("country_tags")
        $(this).find('.tag-label').removeClass 'tag-label-country'
        $(this).find('.tag-label').addClass 'tag-label-country-full'
      else if names.indexOf('office') != -1
        $('#bulk_label').val("office_tags")
        $(this).find('.tag-label').removeClass 'tag-label-office'
        $(this).find('.tag-label').addClass 'tag-label-office-full'
      else if names.indexOf('role') != -1
        $('#bulk_label').val("role_tags")
        $(this).find('.tag-label').removeClass 'tag-label-role'
        $(this).find('.tag-label').addClass 'tag-label-role-full'
      bulk_tag_selected += 1
      $('.get-tag-list').css("opacity", "1")
      $('.get-tag-list').css("pointer-events", "all")
      
      $('#bulk_tag').val($(this).find('.tag-label').text())
    else if class_names.indexOf('user-selected-tag') != -1
      $(this).removeClass 'user-selected-tag'
      $(this).addClass 'user-available-tag'
      $(this).find('.tag-close').text '+'
      names = $(event.target).attr('class')
      if names.indexOf('country') != -1
        $(this).find('.tag-label').addClass 'tag-label-country'
        $(this).find('.tag-label').removeClass 'tag-label-country-full'
      else if names.indexOf('office') != -1
        $(this).find('.tag-label').addClass 'tag-label-office'
        $(this).find('.tag-label').removeClass 'tag-label-office-full'
      else if names.indexOf('role') != -1
        $(this).find('.tag-label').addClass 'tag-label-role'
        $(this).find('.tag-label').removeClass 'tag-label-role-full'
      bulk_tag_selected -= 1
      $('.get-tag-list').css("opacity", "0.5")
      $('.get-tag-list').css("pointer-events", "none")
      $('#bulk_label').val("")
      $('#bulk_tag').val("")
    return

  $($('#profile_name_language').parent()).click (event) ->
    set_language_border_colour('profile_name_language')

  $('#profile_name_language').attr("data-prev", $('#profile_name_language').val())

  $($('#glossary_name_language').parent()).click (event) ->
    set_language_border_colour('glossary_name_language')

  $('#glossary_name_language').attr("data-prev", $('#glossary_name_language').val())

  $('.function_lang_select').change (event) ->
    set_language_name_display(event.target, $(event.target).attr("data-function-type"))

  $($('#faq_name_language').parent()).click (event) ->
    set_language_border_colour('faq_name_language')

  $('#faq_name_language').attr("data-prev", $('#faq_name_language').val())

  $($('#checklist_name_language').parent()).click (event) ->
    set_language_border_colour('checklist_name_language')

  $('#checklist_name_language').attr("data-prev", $('#checklist_name_language').val())

  $($('#notification_name_language').parent()).click (event) ->
    set_language_border_colour('notification_name_language')

  $('#notification_name_language').attr("data-prev", $('#notification_name_language').val())

  $($('#people_name_language').parent()).click (event) ->
    set_language_border_colour('people_name_language')

  $('#people_name_language').attr("data-prev", $('#people_name_language').val())

  $('.menu-item-enable-tags').change (event) ->
    if $(this).is(':checked')
      $(this).parent().siblings('.select-tag-type').css("display", "block")
    else
      $(this).parent().siblings('.select-tag-type').css("display", "none")
    return
    
  $('.tag-type-switch').change (event) ->
    tag_toggle = confirm("All existing tags assigned will be cleared.")
    if (tag_toggle == false)
      $(this)[0].checked = !($(this)[0].checked)
    return
    
  $('.rule-tag-type-switch').change (event) ->
    tag_toggle = confirm("All existing rules assigned to checklist/category will be cleared.")
    if (tag_toggle == false)
      $(this)[0].checked = !($(this)[0].checked)
    $(this).submit();
    return
 
  if $('.edit-categories-main-container').length > 0
    $('.edit-categories-main-container').sortable({
      cursor: "grab"
    });
    $('.edit-categories-main-container').on('sortstart', ->
      $(this).parents('.mam-right.col.l9.m9.right').css('background', '#B2B2B2')
      $(this).sortable( "option", "cursor", "grabbing" );
    )
    $('.edit-categories-main-container').on('sortchange', (event, ui) ->
      change_order = true
    )
    $('.edit-order-main-container').sortable({
      cursor: "grab",
      items: ".category-item",
    });
    $('.edit-order-main-container').on('sortstart', ->
      $(this).parents('.mam-right.col.l9.m9.right').css('background', '#B2B2B2')
      $(this).sortable( "option", "cursor", "grabbing" );
    )
    $('.edit-order-main-container').on('sortchange', (event, ui) ->
      change_item_order = true
    )
    $('.cancel_delete_category').on('click', ->
      $('#delete_category_popup').closeModal()
      setTimeout (->
        $(parentModal).openModal()
        return
      ), 250
    )
    $('#delete_category').on('click', ->
      $('#delete_category_popup').closeModal()
      $(uiItem.item).remove()
      unless deleteUrl == undefined
        $.ajax(
          type: 'DELETE',
          url: deleteUrl,
          enctype: 'multipart/form-data',
          dataType: 'script'
        ).done((data, textStatus, jqXHR) ->
          return
        ).fail((jqXHR, textStatus, errorThrown) ->
          return
        )
      setTimeout (->
        uiItem = ''
        deleteUrl = ''
        $(parentModal).openModal()
        index = 0
        length = $(parentModal).find('.category-index-number').length
        while index < length
          $($(parentModal).find('.category-index-number')[index]).html(parseInt(index / $('#language_ids').val().split(',').length) + 1)
          index++
        return
      ), 250
    )
    $('.edit-category-button').on('click', (e) ->
      e.preventDefault()
      allowEdit = false
      $(this).parents('.edit-category-container').removeClass('active-edit-category-container')
      $(this).parents('.edit-category-container').find('.edit-category-input').hide()
      $(this).parents('.edit-category-container').find('.edit-runtime-input').hide()
      $(this).parents('.edit-category-container').find('.edit-category-button').hide()
      $(this).parents('.edit-category-container').find('.category-order-icon').show()
      $(this).parents('.edit-category-container').find('.modal-for-profile-tag').show()
      $(this).parents('.edit-category-container').find('.category-runtime-icon').show()
      text = $(this).parents('.edit-category-container').find('.edit-category-input').val()
      runtime = $(this).parents('.edit-category-container').find('.edit-runtime-input').val()
      $(this).parents('.edit-category-container').find('.order-item-name').show()
      $(this).parents('.edit-category-container').find('.order-item-name').html(text)
      $(this).parents('.edit-category-container').find('.order-item-name').data('name', text)
      $(this).parents('.edit-category-container').find('.fa-tags').css("display", '')
      if !!text
        $(this).parents('.edit-category-container').find('.order-item-name').removeClass('grayed-out')
      if !!runtime
        $(this).parents('.edit-category-container').find('span.category-runtime-icon').html(runtime)
        $(this).parents('.edit-category-container').find('span.category-runtime-icon').parent().removeClass()
        $(this).parents('.category-item').find('.edit-runtime-input').val(runtime)
      else
        $(this).parents('.edit-category-container').find('span.category-runtime-icon').parent().addClass('display-none')
        $(this).parents('.category-item').find('.edit-runtime-input').val('')
    )
    $('.add-category-button').on('click', (e) ->
      e.preventDefault()
      window.allowAdd = false
      element = ''
      l_ids = $('#language_ids').val().split(',')
      ln_id = $(this).data('language-id')
      p_t_id = $(this).data('people-type-id')
      f_t_id = $(this).data('faq-type-id')
      c_t_id = $(this).data('checklist-type-id')
      g_t_id = $(this).data('glossary-type-id')
      category_name = ''
      category_container = ''
      if p_t_id
        category_name = 'people'
        category_container = p_t_id
      if f_t_id
        category_name = 'faq'
        category_container = f_t_id
      if c_t_id
        category_name = 'checklist'
        category_container = c_t_id
      if g_t_id
        category_name = 'glossary'
        category_container = g_t_id
      text = $(this).parents('.add-category-container').find('.add-category-input').val()
      runtime = $(this).parents('.add-category-container').find('.add-runtime-input').val()
      $(this).parents('.add-category-container').removeClass('active-edit-category-container')
      $(this).parents('.add-category-container').find('.add-category-input').hide()
      $(this).parents('.add-category-container').find('.add-runtime-input').hide()
      $(this).parents('.add-category-container').find('.add-runtime-input').val('')
      $(this).parents('.add-category-container').find('.add-category-button').hide()
      $(this).parents('.add-category-container').find('.add-category-placeholder').show()
      if text.length > 0
        $(this).parents('.add-category-container').find('.add-category-input').val('')
        count = parseInt(($('.category-index-number').length / $('#language_ids').val().split(',').length) + 1)
        for l_id in l_ids
          if l_id == ln_id.toString()
            display =  'block'
            textt = text
            span_class = ''
          else
            display = 'none'
            textt = ''
            span_class = 'grayed-out'
          element += "
                      <div class='edit-category-container multi-lanuage-field #{category_name}-category-#{category_container}-#{l_id}' style='display: #{display};'>
                        <span class='category-index-number'>#{count}</span>
                        <span data-name='#{textt}' data-delete='false' class='order-item-name #{span_class}'>#{text}</span>
                        <i class='category-order-icon fa fa-bars right active'></i>
                      "
          element +=  "<span class='category-runtime-icon right'>#{runtime}</span>
                        <i class='category-runtime-icon fa fa-calendar right'></i>
                      " if !!runtime && runtime.length > 0
          element +=  "<input class='edit-category-input' id='category_#{category_count}_category' name='category[#{category_count}][category_multi][#{l_id}]' type='text' value='#{textt}'>
                        <button class='edit-category-button'>edit</button>
                      </div>
                    "
        $("<div class='category-item ui-sortable-handle'>#{element}</div>").insertBefore('.edit-categories-main-container .clearfix')
        category_count--
    )
    $('.edit-categories-main-container').on('sortstop', (event, ui) ->
      parentModal = $(this).parents('.modal')
      uiItem = ui
      itemOffset = parentModal.offset()
      diff = ui.offset.left - itemOffset.left
      if $($(ui.item).find('.order-item-name')[0]).data('delete') == true && diff > 500
        id = $($(ui.item).find('.order-item-name')[0]).data('id')
        deleteUrl = $($(ui.item).find('.order-item-name')[0]).data('url')
        delete_item_name = $($(ui.item).find('.order-item-name')[0]).data('delete-item-name')
        $('#delete_category_popup').openModal();
        if delete_item_name
          $('.delete_item_name').html(delete_item_name)
        else
          $('.delete_item_name').html('category')

      $($(ui.item)[0]).css('background', '#FFFFFF')
      $($(ui.item)[0]).css('color', '#000000')
      index = 0
      length = $(this).find('.category-index-number').length
      $(this).parents('.mam-right.col.l9.m9.right').css('background', '#FFFFFF')
      $('.edit-categories-main-container').sortable( "option", "cursor", "grab" );
      category_order = []
      while index < length
        $($(this).find('.category-index-number')[index]).html(parseInt((index / $('#language_ids').val().split(',').length) + 1))
        name = $($(this).find('.order-item-name')[index]).data('name')
        category_order.push $($(this).find('.order-item-name')[index]).data('id')
        $($(this).find('.order-item-name')[index]).html(name)
        $($(this).find('.order-item-name')[index]).data('delete', false)
        index++

      if change_order
        url = $(this).data('url')
        change_order = false
        $.ajax(
          type: 'POST',
          url: url
          enctype: 'multipart/form-data',      
          data:
            category_order: category_order,
            selected_manager_preset: $('#selected_manager_preset').val()
        ).done((data, textStatus, jqXHR) ->
          return
        ).fail((jqXHR, textStatus, errorThrown) ->
          return
        )
    )
    $('.edit-order-main-container').on('sortstop', (event, ui) ->
      parentModal = $(this).parents('.modal')
      uiItem = ui
      itemOffset = parentModal.offset()
      diff = ui.offset.left - itemOffset.left

      $('.edit-category-container').css('background', '#FFFFFF')
      $('.edit-category-container').css('color', '#000000')
      index = 0
      length = $(this).find('.category-index-number').length
      $(this).parents('.mam-right.col.l9.m9.right').css('background', '#FFFFFF')
      $('.edit-order-main-container').sortable( "option", "cursor", "grab" );
      menu_item_order = []
      while index < length
        $($(this).find('.category-index-number')[index]).html(index + 1)
        name = $($(this).find('.order-item-name')[index]).data('name')
        menu_item_order.push $($(this).find('.order-item-name')[index]).data('id')
        $($(this).find('.order-item-name')[index]).html(name)
        $($(this).find('.order-item-name')[index]).data('delete', false)
        index++

      if change_item_order
        url = $('.edit-order-main-container').data('url')
        $('.menu-item-order-updated').show()
        $('.menu-item-order-updated').find('.fa-check').addClass('fa-spinner').addClass('fa-spin')
        $('.menu-item-order-updated').find('.fa-check').removeClass('fa-check')
        $('.menu-item-order-updated').find('span').html('')
        $('.menu-item-order-updated').css('color', '#6E6E6E')
        change_item_order = false
        $.ajax(
          type: 'POST',
          url: url
          enctype: 'multipart/form-data',
          data:
            menu_item_order: menu_item_order
        ).done((data, textStatus, jqXHR) ->
          $('.menu-item-order-updated').show()
          $('.menu-item-order-updated').find('.fa-spin').removeClass('fa-spin')
          $('.menu-item-order-updated').find('.fa-spinner').addClass('fa-check')
          $('.menu-item-order-updated').find('.fa-spinner').removeClass('fa-spinner')
          $('.menu-item-order-updated').find('span').html('Order Changed!')
          $('.menu-item-order-updated').css('color', '#369B36')
          setTimeout (->
            $('.menu-item-order-updated').hide(500)
          ), 2000

          return
        ).fail((jqXHR, textStatus, errorThrown) ->
          return
        )
    )
    $('.edit-categories-main-container').on('sortout', (event, ui) ->
      modal = $(this).parents('.modal')
      itemOffset = modal.offset()
      diff = ui.offset.left - itemOffset.left
      if diff > 500
        $($(ui.item)[0]).find('.edit-category-input').hide()
        $($(ui.item)[0]).find('.edit-runtime-input').hide()
        $($(ui.item)[0]).find('.edit-category-button').hide()
        $($(ui.item)[0]).css('background', '#FF6A61')
        $($(ui.item)[0]).css('color', '#FFFFFF')
        $($(ui.item)[0]).find('.order-item-name').show()
        $($(ui.item)[0]).find('.category-order-icon').show()
        $($(ui.item)[0]).find('.category-runtime-icon').show()
        $($(ui.item)[0]).find('.order-item-name').html('DELETE?')
        $($(ui.item)[0]).find('.order-item-name').data('delete', true)
    )
    $('.edit-categories-main-container').on('sortover', (event, ui) ->
      $($(ui.item)[0]).css('background', '#FFFFFF')
      $($(ui.item)[0]).css('color', '#000000')
      name = $($(ui.item)[0]).find('.order-item-name').data('name')
      $($(ui.item)[0]).find('.order-item-name').html(name)
      $($(ui.item)[0]).find('.order-item-name').data('delete', false)
    )
    $('.edit-order-main-container').on('sortover', (event, ui) ->
      $($(ui.item)[0]).css('background', '#FFFFFF')
      $($(ui.item)[0]).css('color', '#000000')
      name = $($(ui.item)[0]).find('.order-item-name').data('name')
      $($(ui.item)[0]).find('.order-item-name').html(name)
      $($(ui.item)[0]).find('.order-item-name').data('delete', false)
    )
  add_edit_category_callbacks()
  
  $("#new_people_category").bind('ajax:complete', ->
    add_edit_category_callbacks()
  )
  $("#new_faq_category").bind('ajax:complete', ->
    add_edit_category_callbacks()
  )
  $("#new_checklist_category").bind('ajax:complete', ->
    add_edit_category_callbacks()
  )
  $("#new_glossary_category").bind('ajax:complete', ->
    add_edit_category_callbacks()
  )

  GLOSSARY_FILE_LIMITS = $('#glossary_file_limits').val() && JSON.parse($('#glossary_file_limits').val())
  PERSON_FILE_LIMITS = $('#person_file_limits').val() && JSON.parse($('#person_file_limits').val())

  $('.edit-person-image-selector').change (event) ->
    $(this).siblings('.add-people-finder-person-image').show()
    fileObject = {}
    file_preview = $(event.target).parents('.add-per-avatar').find('.avatar-container img')
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype = file.type
    fileObject.filename = file.name

    return if fileSizeNotInLimit(file, event, null, PERSON_FILE_LIMITS["image"])

    reader = new FileReader

    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      cropbox.attr "src", image_base64
      return

    reader.readAsDataURL file
    return

  $('.modal-for-person').click ->
    $('#personmodal').openModal()
    $("#personmodal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
    return

  $('.add-people-finder-person-image').click (event) ->
    modal_to_close = "#mdl_addperson_popup"
    modal_to_open = "#addPersonImageModal"
    $(modal_to_close).closeModal();
    setTimeout (->
      $(modal_to_open).openModal()
      $(cropbox).attr "src", $($(event.target)[0]).siblings('.add-upload-preview-ipad').find("img").attr("src")

      $(".add-upload-preview").removeClass "add-upload-preview"
      $(".add-upload-preview-ipad").addClass "add-upload-preview"

      add_croppie_people = $('.add-croppie-ipad').croppie({
        viewport: {
          width: 300,
          height: 300,
          type: 'circle'
        }
      });
      if $('#addPersonImageModal').find('.croppie-container').length > 1
        $('#addPersonImageModal').find('.croppie-container:last').appendTo('#addPersonImageModal .main-image-container')
        $('#addPersonImageModal').find('.croppie-container:first').remove()
    ), 250

  $('.add-back-person-modal').click ->
    modal_to_close = "#addPersonImageModal";
    modal_to_open = "#mdl_addperson_popup";
    $(modal_to_close).closeModal();
    setTimeout (->
      $(modal_to_open).openModal()
      return
    ), 250

  $('.add-save-cropped-image-btn').click ->
    if add_croppie_people
      src = add_croppie_people.get(0).src
      format = add_croppie_people.get(0).src.split(';')[0].split('/')[1]
      if !format
        format = 'jpeg'
      add_croppie_people.croppie('result',
        type: 'canvas'
        size: 'original'
        format: format
        quality: '0.99'
      ).then (response) ->
        $('.add-upload-preview-ipad img').attr('src', response)

  $(".glossary-image-file").change (event) ->
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file

    return if fileSizeNotInLimit(file,event,null,GLOSSARY_FILE_LIMITS["image"])

  $('#people-category-settings').change ->
    $.ajax(
      type: 'GET'
      url: '/people_category_settings/' + $(this).val(),
    ).done((data, textStatus, jqXHR) ->
      $('.category-settings-container').html(data)
    )

  $(document).on 'click', '.menu-item-language', ->
    $(this).parents('form').find('.menu-item-language').removeClass('selected')
    $(this).addClass('selected')
    l_id = $(this).data('language-id')
    g_id = $(this).data('glossary-id')
    f_id = $(this).data('faq-id')
    c_id = $(this).data('checklist-id')
    selected_category = $("div[id^='category-for-']:visible").find('select').val()
    $(this).parents('form').find('.multi-lanuage-field').hide()
    $('.modal:visible').find('#category-for-'+l_id).css("display", "block")
    $("div[id^='category-for-']:visible").find('select').val(selected_category)
    $("div[id^='category-for-']:visible").find('select').trigger("chosen:updated")
    if g_id
      $('#glossary-name-'+g_id+'-'+l_id).css("display", "block")
      $('#glossary-description-'+g_id+'-'+l_id).css("display", "block")
    if f_id
      $('#faq-question-'+f_id+'-'+l_id).css("display", "block")
      $('#faq-answer-'+f_id+'-'+l_id).css("display", "block")
    if c_id
      $('#checklist-item-'+c_id+'-'+l_id).css("display", "block")

  $('.menu-item-category-language').click (event) ->
    $(this).parents('.modal').find('.menu-item-category-language').removeClass('selected')
    $(this).addClass('selected')
    $(this).parents('.modal').find('.multi-lanuage-field').hide()
    $(this).parents('.modal').find('.add-category-container').hide()
    l_id = $(this).data('language-id')
    p_t_id = $(this).data('people-type-id')
    f_t_id = $(this).data('faq-type-id')
    c_t_id = $(this).data('checklist-type-id')
    g_t_id = $(this).data('glossary-type-id')
    mc_t_id = $(this).data('manager-checklist-type-id')
    mc_r_id = $(this).data('manager-rule-id')
    if p_t_id
      $('.people-category-'+p_t_id+'-'+l_id).css("display", "block")
    if f_t_id
      $('.faq-category-'+f_t_id+'-'+l_id).css("display", "block")
    if c_t_id
      $('.checklist-category-'+c_t_id+'-'+l_id).css("display", "block")
    if g_t_id
      $('.glossary-category-'+g_t_id+'-'+l_id).css("display", "block")
    if mc_t_id
      $('.manager-checklist-category-'+mc_t_id+'-'+l_id).css("display", "block")
    if mc_r_id
      $('.manager-checklist-rule-'+mc_r_id+'-'+l_id).css("display", "block")

  $('#menu_item_name_language').change (event) ->
    l_id = $(this).val()
    url = window.location.pathname
    params = new URL(window.location.href).searchParams
    params.delete 'selected'
    params.append 'selected', l_id
    url += '?' + params
    window.location.href = url
    return

  set_language_name_display = (object, menu_item_name) ->
    function_id = $(object).attr("data-function-id")
    prev_language_id = $(object).attr("data-prev")
    current_language_id = $(object).val()
    $(object).attr("data-prev", current_language_id)
    $('#' + menu_item_name + '-name-' + current_language_id + '--' + function_id).css("display", "block")
    $('#' + menu_item_name + '-name-' + prev_language_id + '--' + function_id).css("display", "none")

  set_language_border_colour = (language_id) ->
    for result in $('#' + language_id + '_chosen .chosen-results').children()
      text = $(result).text()
      key = $('#' + language_id).find('option:contains("'+text+'")').val()
      for id in $('#' + language_id).parents('form').find('input[id^="function_name_multi"]')
        if $(id).attr("id") == 'function_name_multi[' + key + ']'
          match = $(id).val()
          break
      if match.length > 0
        $(result).addClass("language-green")
        $(result).removeClass("language-orange")
      else
        $(result).addClass("language-orange")
        $(result).removeClass("language-green")

add_edit_category_callbacks = () ->
  $('.add-category-placeholder').show()
  $('.add-category-input').hide()
  $('.add-category-input').val('')
  $('.add-category-button').hide()
  $('.add-tip-category-button').hide()
  $('.add-manager-checklist-category-button').hide()

  $('.add-category-container').click ->
    if window.allowAdd
      if $(this).parents('.people').length == 0
        $(this).addClass('active-edit-category-container')
      $(this).find('.add-category-placeholder').hide()
      $(this).find('.add-category-input').show()
      $(this).find('.add-runtime-input').show()
      $(this).find('.add-category-button').show()
      $(this).find('.add-tip-category-button').show()
      $(this).find('.add-manager-checklist-category-button').show()
    window.allowAdd = true
    
  $('.edit-category-container').click (event) ->
    if (allowEdit && (($(event.target).attr("data_link")) != '#category-tag'))
      if $(this).parents('.people').length == 0
        $(this).addClass('active-edit-category-container')
      $(this).find('.order-item-name').hide()
      $(this).find('.category-order-icon').hide()
      $(this).find('.modal-for-profile-tag').hide()
      $(this).find('.category-runtime-icon').hide()
      $(this).find('.fa-tags').hide()
      $(this).find('.edit-category-input').show().removeClass('display-none')
      $(this).find('.edit-runtime-input').show().removeClass('display-none')
      $(this).find('.edit-category-button').show().removeClass('display-none')
    allowEdit = true

  $('#profile_show_first_day').click () ->
    if !($(this).is(':checked')) && $('#profile_edit_first_day').is(':checked')
      $('#profile_edit_first_day').click()

  $('#profile_edit_first_day').click () ->
    if $(this).is(':checked') && !($('#profile_show_first_day').is(':checked'))
      $('#profile_show_first_day').click()
